import "core-js/modules/es.object.assign.js";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

function WarmWater(props) {
  return React.createElement(Svg, _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24"
  }, props), React.createElement(Path, {
    fillRule: "evenodd",
    d: "M12 4a5.099 5.099 0 00-5 4.099l-.927 5.637A3.565 3.565 0 009.568 18h4.864a3.565 3.565 0 003.495-4.264L17 8.1A5.099 5.099 0 0012 4zM5.039 7.707a7.099 7.099 0 0113.922 0l.928 5.637c.581 2.907-1.206 5.65-3.889 6.433V21h1a1 1 0 110 2h-2a1 1 0 01-1-1v-2h-4v2a1 1 0 01-1 1H7a1 1 0 110-2h1v-1.223c-2.684-.783-4.47-3.526-3.889-6.433l.928-5.637zM11.5 6a1 1 0 100 2h1a1 1 0 100-2h-1zm-.5 8a1 1 0 112 0 1 1 0 01-2 0zm1-3a3 3 0 100 6 3 3 0 000-6z",
    clipRule: "evenodd"
  }));
}

export default WarmWater;